<footer class="border-t border-border/40 bg-background/50 backdrop-blur-sm">
  <div class="container mx-auto px-4 py-12">

    <div class="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
      <!-- BRAND -->
      <div class="md:col-span-2">
        <h3 class="font-display text-xl font-bold mb-4">AI.Engineer</h3>
        <p class="text-muted-foreground text-sm max-w-sm leading-relaxed">
          I continuously seek opportunities to transform research-driven AI knowledge into deployable and scalable solutions.
        </p>
      </div>

      <!-- NAV -->
      <div>
        <h4 class="font-bold text-sm uppercase tracking-wider text-muted-foreground mb-4">
          Navigation
        </h4>
        <ul class="space-y-2 text-sm">
          <li>
            <a routerLink="/" class="hover:text-primary transition-colors">Home</a>
          </li>
          <li>
            <a routerLink="/projects" class="hover:text-primary transition-colors">Projects</a>
          </li>
          <li>
            <a routerLink="/blog" class="hover:text-primary transition-colors">Blog</a>
          </li>
        </ul>
      </div>

      <!-- SOCIAL -->
      <div>
        <h4 class="font-bold text-sm uppercase tracking-wider text-muted-foreground mb-4">
          Connect
        </h4>

        <div class="flex gap-4">
          <app-button variant="destructive" class="gap-2"><a href="asset/doc/burakhan-samli-cv.pdf" download="" class="cv-button">GET CV</a></app-button>


          <!-- GitHub -->
          <a href="https://github.com/blitzkrieg0000" target="_blank" rel="noreferrer" class="p-2 rounded-lg bg-secondary/50 hover:bg-primary/20 hover:text-primary transition-colors">
            <!-- GitHub SVG -->
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 .5C5.73.5.5 5.74.5 12.02c0 5.11 3.29 9.45 7.86 10.98.57.1.78-.25.78-.55v-2.1c-3.2.7-3.88-1.55-3.88-1.55-.53-1.34-1.3-1.7-1.3-1.7-1.06-.73.08-.72.08-.72 1.17.08 1.79 1.21 1.79 1.21 1.04 1.79 2.74 1.27 3.41.97.1-.75.41-1.27.74-1.56-2.55-.29-5.23-1.28-5.23-5.69 0-1.26.45-2.29 1.19-3.1-.12-.3-.52-1.5.11-3.13 0 0 .97-.31 3.18 1.18.92-.26 1.9-.38 2.88-.38.98 0 1.96.13 2.88.38 2.2-1.5 3.18-1.18 3.18-1.18.63 1.63.23 2.83.11 3.13.74.81 1.19 1.84 1.19 3.1 0 4.42-2.69 5.39-5.25 5.67.42.36.79 1.07.79 2.16v3.2c0 .3.21.66.79.55A11.52 11.52 0 0023.5 12C23.5 5.74 18.27.5 12 .5z" />
            </svg>
          </a>

          <!-- LinkedIn -->
          <a href="https://www.linkedin.com/in/burakhan-şamlı-0000/" target="_blank" rel="noreferrer" class="p-2 rounded-lg bg-secondary/50 hover:bg-primary/20 hover:text-primary transition-colors">
            <svg class="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4V24h-4zM8.5 8h3.8v2.2h.05c.53-1 1.83-2.2 3.77-2.2 4.03 0 4.78 2.65 4.78 6.1V24h-4v-7.7c0-1.84-.03-4.2-2.56-4.2-2.56 0-2.95 2-2.95 4.07V24h-4z" />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <!-- BOTTOM -->
    <div class="border-t border-border/40 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
      <p class="text-xs text-muted-foreground">
        © 2025 BlitzKrieg Engineer Portfolio. All rights reserved.
      </p>


      <a href="mailto:burakhansamli@proton.me" class="flex items-center gap-2 text-xs font-mono text-muted-foreground hover:text-primary transition-colors">
        <lucide-icon [img]="MailIcon" class="w-4 h-4 text-muted-foreground"></lucide-icon> burakhansamli@proton.me
      </a>
    </div>
  </div>
</footer>